// utils/secureFetch.js
import { auth } from '../config/firebase';
import { redirectToLogin } from './navigationHelper';

let cachedToken = null;
let lastTokenTime = 0;
const TOKEN_TTL = 55 * 60 * 1000; // 55 minutos

export const secureFetch = async (url, options = {}) => {
  const user = auth.currentUser;
  if (!user) {
    console.warn('Usuario no autenticado');
    throw new Error('Usuario no autenticado');
  }

  const now = Date.now();
  const isExpired = !cachedToken || (now - lastTokenTime) > TOKEN_TTL;

  // Si no hay token o ya expiró, pido uno nuevo
  if (isExpired) {
    try {
      cachedToken = await user.getIdToken(true);
      lastTokenTime = now;
    } catch (err) {
      console.error('Error obteniendo token:', err);
      await auth.signOut();
      localStorage.clear();
      redirectToLogin();
      throw new Error('Fallo al renovar token');
    }
  }

  // Armo headers con el token fresco o cacheado
  const headers = {
    ...options.headers,
    Authorization: `Bearer ${cachedToken}`,
  };

  // Solo agregar Content-Type si no es FormData
  // FormData necesita que el navegador establezca el Content-Type automáticamente con el boundary
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    console.warn('Sesión expirada (401). Cerrando sesión...');
    await auth.signOut();
    localStorage.clear();
    redirectToLogin();
    throw new Error('Sesión expirada');
  }

  return response;
};
